module.exports = __webpack_public_path__ + "img/sign-58.d92b3b02.jpg";